var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5H4V0.5H0V4.5ZM6 16.5H10V12.5H6V16.5ZM0 16.5H4V12.5H0V16.5ZM0 10.5H4V6.5H0V10.5ZM6 10.5H10V6.5H6V10.5ZM12 0.5V4.5H16V0.5H12ZM6 4.5H10V0.5H6V4.5ZM12 10.5H16V6.5H12V10.5ZM12 16.5H16V12.5H12V16.5Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilitiesIcon);
export default __webpack_public_path__ + "static/media/FacilitiesIcon.a7f1395ec37e9d284b4f745c4c85a0ea.svg";
export { ForwardRef as ReactComponent };